import { useNavigate } from "react-router-dom";

const ziua1 = [
  "11.jpg",
  "12.jpg",
  "13.jpg",
  "14.jpg",
  "16.jpg",
  "17.jpg",
  "18.jpg",
  "19.jpg",
  "20.jpg",
  "21.jpg",
  "22.jpg",
  "23.jpg",
  "24.jpg",
  "26.jpg",
  "27.jpg",
  "28.jpg",
  "29.jpg",
  "30.jpg",
  "31.jpg",
  "32.jpg",
  "33.jpg",
  "34.jpg",
  "35.jpg",
  "36.jpg",
  "37.jpg",
  "38.jpg",
  "39.jpg",
  "40.jpg",
  "41.jpg",
  "42.jpg",
  "43.jpg",
  "44.jpg",
  "45.jpg",
  "46.jpg",
  "47.jpg",
  "48.jpg",
  "49.jpg",
  "50.jpg",
  "51.jpg",
  "52.jpg",
  "53.jpg",
  "58.jpg",
  "59.jpg",
  "60.jpg",
  "61.jpg",
  "62.jpg",
  "63.jpg",
  "64.jpg",
  "65.jpg",
  "66.jpg",
  "67.jpg",
  "68.jpg",
  "69.jpg",
  "70.jpeg",
  "71.jpeg",
  "72.jpeg",
  "73.jpeg",
  "74.jpeg",
];

const ziua2 = [
  "11.jpeg",
  "12.jpeg",
  "13.jpeg",
  "14.jpeg",
  "15.jpeg",
  "16.jpeg",
  "17.jpeg",
];

const ziua3 = [
  "1.jpg",
  "2.jpg",
  "3.jpg",
  "4.jpg",
  "5.jpg",
  "6.jpg",
  "7.jpg",
  "8.jpg",
  "9.jpg",
  "10.jpg",
  "11.jpg",
  "12.jpg",
  "13.jpg",
  "14.jpg",
  "15.jpg",
  "16.jpg",
  "17.jpg",
  "18.jpg",
  "19.jpg",
  "20.jpg",
  "21.jpg",
  "22.jpg",
  "23.jpg",
  "24.jpg",
  "25.jpg",
  "26.jpg",
  "27.jpg",
  "28.jpg",
  "29.jpg",
  "30.jpg",
  "31.jpg",
  "32.jpg",
  "33.jpg",
  "34.jpg",
  "35.jpg",
  "36.jpg",
  "37.jpg",
  "38.jpg",
  "39.jpg",
  "40.jpg",
  "41.jpg",
  "42.jpg",
  "43.jpeg",
];

const ziua4 = [
  "41.jpeg",
  "42.jpeg",
  "43.jpeg",
  "44.jpeg",
  "45.jpeg",
  "46.jpeg",
  "47.jpeg",
];

const ziua5 = [
  "51.jpg",
  "52.jpg",
  "53.jpg",
  "54.jpg",
  "55.jpg",
  "56.jpg",
  "57.jpg",
  "58.jpg",
  "59.jpg",
  "60.jpg",
  "61.jpg",
  "62.jpg",
  "63.jpg",
  "64.jpg",
  "65.jpg",
  "66.jpg",
  "67.jpg",
  "68.jpg",
  "69.jpg",
];

export default function RomaniaPage() {
  const navigate = useNavigate();

  function PhotoGrid({ images, folder }) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {images.map((img, idx) => (
          <div
            key={img}
            className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <img
              src={
                `/proiecte/Erasmus+/pozeRomania/${folder}/${img}`
              }
              alt={`Romania Erasmus ${idx + 1}`}
              className="object-cover w-full h-full"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Întâlnire de lucru în ULMENI, MARAMUREȘ, ROMÂNIA, în cadrul
          proiectului Erasmus+ KA229 „OUR PAST OUR FUTURE“ 9.05.2022-13.05.2022
        </h1>
        <p className="mb-4">
          Proiectul Erasmus+ înseamnă prietenie, bucurie, călătorie spre noi
          orizonturi, dezvoltarea capacității de învățare prin cooperare și
          creșterea stimei de sine. Activitățile derulate în săptămâna în care
          Liceul Tehnologic "Dr. F. Ulmeanu " Ulmeni a fost gazda delegațiilor
          din țările participante în proiect, precum Grecia, Turcia, Letonia și
          Italia, au fost o reușită. Participanții au apreciat diversitatea
          atelierelor de lucru, obiceiurile și tradițiile locale, ospitalitatea
          și buna organizare a activităților. Elevii și profesorii au trăit
          experiențe unice, legându-se prietenii pe termen îndelungat.
        </p>
        <p className="mb-4">Luni, 09.05.2022</p>
        <PhotoGrid images={ziua1} folder="1" />
        <p className="mb-4">Marți, 10.05.2022</p>
        <PhotoGrid images={ziua2} folder="2" />
        <p className="mb-4">Miercuri, 11.05.2022</p>
        <PhotoGrid images={ziua3} folder="3" />
        <p className="mb-4">Joi, 12.05.2022</p>
        <PhotoGrid images={ziua4} folder="4" />
        <p className="mb-4">Vineri, 13.05.2022</p>
        <PhotoGrid images={ziua5} folder="5" />

        <button
          onClick={() => navigate("/proiecte/erasmus+")}
          className="m-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 float-right"
        >
          &larr; Înapoi
        </button>
      </main>
    </div>
  );
}
